import { createAsyncThunk } from "@reduxjs/toolkit";

const API_BASE = process.env.REACT_APP_API_BASE;
const API_KEY = process.env.REACT_APP_API_KEY

/**
 * fetch all Vendorrecommendations entries
 */
export const fetchVendorrecommendationsItems = createAsyncThunk(
  "vendorrecommendations/fetchItems",
  async () => {
    const res = await fetch(`${API_BASE}/api/vendorrecommendations`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": API_KEY
      }
    });
    const json = await res.json();
    if (!res) {
      throw new Error(json?.message || "Fetch failed");
    }
    return json;
  }
);

// POST a new vendor recommendation
export const postVendorrecommendation = createAsyncThunk(
  "vendorrecommendations/postItem",
  async (data, { rejectWithValue }) => {
    try {
      const res = await fetch(`${API_BASE}/api/vendorrecommendations`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": API_KEY,
        },
        body: JSON.stringify(data),
      });

      const json = await res.json();

      if (!res.ok) {
        return rejectWithValue(json?.message || "Failed to submit recommendation");
      }

      return json;
    } catch (error) {
      return rejectWithValue(error.message || "Unexpected error");
    }
  }
);